'use client'
import {
  useConfig_default
} from "./chunk-UDUUTZIS.mjs";

// src/hooks/useAppLoading.ts
var useAppLoading = () => {
  const { appLoadingComponent } = useConfig_default();
  return {
    appLoadingComponent
  };
};

export {
  useAppLoading
};
//# sourceMappingURL=chunk-ADQ4TKBZ.mjs.map